import React from "react";
import qrImage from "../image-qr-code.png";
import "./qrComponent.css";

function QrComponenet() {
  return (
    <>
      <div className="small-screen-container">
        <p>Please use a larger screen to view this content from 375px.</p>
      </div>
      <div className="container">
        <div className="qrbox">
          <img className="img" src={qrImage} alt="qr-code" />
          <h1>
            Improve your front<span className="dash">-</span>
            <span className="end">end</span> skills by building projects
          </h1>
          <p>
            Scan the QR code to visit Frontend Mentor and take your coding
            skills to the next level
          </p>
        </div>
      </div>
    </>
  );
}

export default QrComponenet;
